// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hrleavepg-inline-1 {
  display: flex;
  gap: 8px;
  margin-bottom: 16px;
}

.hrleavepg-inline-2 {
  width: 100%;
}

.hrleavepg-inline-3 {
  font-weight: 600;
}

.hrleavepg-inline-4 {
  font-size: 10px;
  padding: 2px 6px;
  border-radius: 6px;
  background: #f1f5f9;
}

.hrleavepg-inline-5 {
  font-weight: 600;
}

.hrleavepg-inline-6 {
  display: flex;
  gap: 4px;
}

.hrleavepg-inline-7 {
  background: #3b82f6;
  color: #fff;
  border: none;
  border-radius: 4px;
  padding: 3px 8px;
  font-size: 10px;
  cursor: pointer;
  font-weight: 600;
}

.hrleavepg-inline-8 {
  font-size: 10px;
  color: #94a3b8;
}

.hrleavepg-inline-9 {
  text-align: center;
  padding: 20px;
  color: #94a3b8;
}

.hrleavepg-inline-10 {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.hrleavepg-inline-11 {
  background: #fff;
  border-radius: 12px;
  padding: 24px;
  width: 400px;
  max-width: 90vw;
}

.hrleavepg-inline-12 {
  margin: 0 0 16px;
  font-size: 16px;
}

.hrleavepg-inline-13 {
  font-size: 13px;
  margin-bottom: 12px;
}

.hrleavepg-inline-14 {
  width: 100%;
  padding: 8px;
  border-radius: 6px;
  border: 1px solid #e2e8f0;
  font-size: 12px;
  margin-bottom: 12px;
  box-sizing: border-box;
}

.hrleavepg-inline-15 {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
}

.hrleavepg-inline-16 {
  padding: 6px 14px;
  border-radius: 6px;
  border: 1px solid #e2e8f0;
  background: #fff;
  cursor: pointer;
  font-size: 12px;
}

.hrleavepg-inline-17 {
  padding: 6px 14px;
  border-radius: 6px;
  border: none;
  background: #ef4444;
  color: #fff;
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
}

.hrleavepg-inline-18 {
  padding: 6px 14px;
  border-radius: 6px;
  border: none;
  background: #3b82f6;
  color: #fff;
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
}

.hrleavepg-dyn-1 {
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 10px;
  font-weight: 600;
  background: var(--hrleavepg-1-background);
  color: var(--hrleavepg-1-color);
}

.hrleavepg-dyn-2 {
  padding: 6px 14px;
  border-radius: 8px;
  border: 1px solid;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  background: var(--hrleavepg-2-background);
  color: var(--hrleavepg-2-color);
  border-color: var(--hrleavepg-2-border-color);
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/HR/HrLeavePg.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yCAAyC;EACzC,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yCAAyC;EACzC,+BAA+B;EAC/B,6CAA6C;AAC/C","sourcesContent":[".hrleavepg-inline-1 {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 16px;\n}\n\n.hrleavepg-inline-2 {\n  width: 100%;\n}\n\n.hrleavepg-inline-3 {\n  font-weight: 600;\n}\n\n.hrleavepg-inline-4 {\n  font-size: 10px;\n  padding: 2px 6px;\n  border-radius: 6px;\n  background: #f1f5f9;\n}\n\n.hrleavepg-inline-5 {\n  font-weight: 600;\n}\n\n.hrleavepg-inline-6 {\n  display: flex;\n  gap: 4px;\n}\n\n.hrleavepg-inline-7 {\n  background: #3b82f6;\n  color: #fff;\n  border: none;\n  border-radius: 4px;\n  padding: 3px 8px;\n  font-size: 10px;\n  cursor: pointer;\n  font-weight: 600;\n}\n\n.hrleavepg-inline-8 {\n  font-size: 10px;\n  color: #94a3b8;\n}\n\n.hrleavepg-inline-9 {\n  text-align: center;\n  padding: 20px;\n  color: #94a3b8;\n}\n\n.hrleavepg-inline-10 {\n  position: fixed;\n  inset: 0;\n  background: rgba(0,0,0,0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.hrleavepg-inline-11 {\n  background: #fff;\n  border-radius: 12px;\n  padding: 24px;\n  width: 400px;\n  max-width: 90vw;\n}\n\n.hrleavepg-inline-12 {\n  margin: 0 0 16px;\n  font-size: 16px;\n}\n\n.hrleavepg-inline-13 {\n  font-size: 13px;\n  margin-bottom: 12px;\n}\n\n.hrleavepg-inline-14 {\n  width: 100%;\n  padding: 8px;\n  border-radius: 6px;\n  border: 1px solid #e2e8f0;\n  font-size: 12px;\n  margin-bottom: 12px;\n  box-sizing: border-box;\n}\n\n.hrleavepg-inline-15 {\n  display: flex;\n  gap: 8px;\n  justify-content: flex-end;\n}\n\n.hrleavepg-inline-16 {\n  padding: 6px 14px;\n  border-radius: 6px;\n  border: 1px solid #e2e8f0;\n  background: #fff;\n  cursor: pointer;\n  font-size: 12px;\n}\n\n.hrleavepg-inline-17 {\n  padding: 6px 14px;\n  border-radius: 6px;\n  border: none;\n  background: #ef4444;\n  color: #fff;\n  cursor: pointer;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.hrleavepg-inline-18 {\n  padding: 6px 14px;\n  border-radius: 6px;\n  border: none;\n  background: #3b82f6;\n  color: #fff;\n  cursor: pointer;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.hrleavepg-dyn-1 {\n  padding: 2px 8px;\n  border-radius: 10px;\n  font-size: 10px;\n  font-weight: 600;\n  background: var(--hrleavepg-1-background);\n  color: var(--hrleavepg-1-color);\n}\n\n.hrleavepg-dyn-2 {\n  padding: 6px 14px;\n  border-radius: 8px;\n  border: 1px solid;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  background: var(--hrleavepg-2-background);\n  color: var(--hrleavepg-2-color);\n  border-color: var(--hrleavepg-2-border-color);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
